import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

type ToastVariant =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'dark';

interface ToastItem {
  id: number;
  message: string;
  variant?: ToastVariant;
  title?: string;
  autoHide?: number;
}

interface ToasterProps {
  toasts: ToastItem[];
  removeToast: (id: number) => void;
}

const getTextClass = (variant?: ToastVariant) => {
  const lightVariants: ToastVariant[] = ['warning', 'info'];
  if (!variant) {
    return '';
  }
  return lightVariants.includes(variant) ? 'text-dark' : 'text-white';
};

const Toaster: React.FC<ToasterProps> = ({ toasts, removeToast }) => {
  return (
    <ToastContainer
      position="top-center"
      className="p-3 position-fixed top-0 start-50 translate-middle-x"
      style={{ zIndex: 2000 }}
    >
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          {...(toast.variant ? { bg: toast.variant } : {})}
          onClose={() => removeToast(toast.id)}
          show={true}
          delay={toast.autoHide}
          autohide
        >
          {toast.title && (
            <Toast.Header
              closeButton={false}
              className="justify-content-between"
            >
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>
          )}
          <Toast.Body className={getTextClass(toast.variant)}>
            {toast.message}
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};

export default Toaster;
